<template>
  <div :class="`flight-pad-price-button flight-pad-price-button__${direction}`">
    <div class="flight-pad-price-button__box px-1 w-50">
      <div class="flight-pad-price-button__amount">
        <div class="d-flex flex-column">
          <span class="h3 m-0 semibold text-primary text-nowrap">
            {{ currency(flight_offer.price.currency) }}
            {{
              number(get_markup(flight_offer).mu_price).toFixed(2).replace('.', ',')
            }}
          </span>
          <span class="flight-pad-price-button__text text-dark">
            ({{ currency(flight_offer.price.currency) }} {{ number(get_markup(flight_offer).mu_price_medium_per_pax).toFixed(2).replace('.', ',') }}/pers.)
          </span>
        </div>
      </div>
    </div>
    <div class="d-flex px-1 flex-column justify-content-center w-50">
      <custom-link
        :before_navigation="() => select_flight_offer(flight_offer)"
        :route_name="'detail'"
        css_class="d-flex justify-content-center"
        :as_default="get_config('guiSettings.openDetailNewTab', false)"
      >
        >
        <template #content>
          <vb-button
            :vb_options="{
              classes: 'flex-grow-1',
              text: 'Scegli',
              variant: 'info',
              size: 'md',
            }"
          />
        </template>
      </custom-link>
    </div>
  </div>
</template>

<script>
import {
  get_markup,
  select_flight_offer,
} from "@liveflight/utilities/flight-offer";
import { currency } from "@liveflight/utilities/mixins";
import { number } from "mathjs";

export default {
  name: "flight-pad-price-button",
  props: {
    flight_offer: Object,
    direction: {
      type: String,
      default: () => "",
    },
  },
  methods: {
    number,
    currency,
    select_flight_offer,
    get_markup,
  },
};
</script>

<style lang="scss" scoped>
.flight-pad-price-button {
  width: 100%;
  display: flex;
  align-items: center;
  height: 100%;
  .custom-link {
    display: inline-block;
    margin: 0 auto;
  }  
  &__box {
    display: flex;
    font-size: $font-size-lg;
    width: max-content;
  }
  &__currency {
    margin-right: 6px;
  }
  &__amount {
    width: 100%;
    text-align: center;
  }
  &__text {
    font-size: $font-size-sm;
    text-align: center;
  }
  &__horizontal {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 30px;

    &__text {
      text-align: start;
    }
  }

  @include media-breakpoint-down(md) {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-top: $grid-gutter-width / 3;

    &__text {
      text-align: start;
    }
  }
}
</style>
